import React, { useState } from 'react'
import { Button, Container, Modal, Tab, Tabs } from 'react-bootstrap'
import Subscription from './Subscription'
import BillingPayments from './BillingPayments'
import Invoices from './Invoices'
import PageHeader from '../../components/PageHeader'

function SubscriptionManagementPage() {
  const [key, setKey] = useState('subscription')
  const [state, setState] = useState({
    currentPlan: 'pro',
    status: 'active',
    renewalDate: 'November 25, 2024',
    payment: {
      cardNumber: '**** **** **** 1234',
    },
    billingAddress: {
      companyName: 'Trucking Solutions Inc.',
      fullName: 'John Doe',
      address: '1234 Trucker Lane',
      city: 'Logistics City',
      state: 'California',
      country: 'USA',
    },
  })

  // Confirmation modal
  const [confirmModal, setConfirmModal] = useState({
    show: false,
    title: '',
    body: '',
    onConfirm: () => {},
  })

  // Success modal (for after cancellation or plan change)
  const [successModal, setSuccessModal] = useState({
    show: false,
    title: '',
    body: '',
  })

  const handleShowConfirm = (title, body, onConfirm) => {
    setConfirmModal({ show: true, title, body, onConfirm })
  }

  const handleCloseConfirm = () => {
    setConfirmModal({ ...confirmModal, show: false })
  }

  const handleCloseSuccess = () => {
    setSuccessModal({ ...successModal, show: false })
  }

  const handleConfirm = () => {
    confirmModal.onConfirm()
    setConfirmModal({ ...confirmModal, show: false })
  }

  // Plan change (upgrade/downgrade)
  const handlePlanChange = newPlan => {
    const action = newPlan === 'pro' ? 'Upgrade' : 'Downgrade'
    handleShowConfirm(
      `Confirm Plan ${action}`,
      `Are you sure you want to ${action.toLowerCase()} your plan? Your changes will take effect at the end of your current billing cycle.`,
      () => {
        setState(prev => ({ ...prev, currentPlan: newPlan }))
        setSuccessModal({
          show: true,
          title: 'Success!',
          body: `Your plan has been scheduled for a ${action.toLowerCase()}.`,
        })
      }
    )
  }

  // Cancel subscription
  const handleCancelSubscription = () => {
    handleShowConfirm(
      'Cancel Subscription',
      'Are you sure you want to cancel your subscription? You will lose access to all features at the end of your current billing period.',
      () => {
        setState(prev => ({ ...prev, status: 'pending-cancellation' }))
        setSuccessModal({
          show: true,
          title: 'Cancellation Confirmed!',
          body: 'Your subscription has been scheduled for cancellation.',
        })
      }
    )
  }

  return (
    <div>
      <PageHeader name='Subscription and Billing Management' />
      <Container fluid className='container-main subscription_management w-100 '>
        <Tabs id='subscription-tabs' activeKey={key} onSelect={k => setKey(k)} className='mb-3'>
          <Tab eventKey='subscription' title='Subscription'>
            <Subscription
              state={state}
              onPlanChange={handlePlanChange}
              onCancelSubscription={handleCancelSubscription}
            />
          </Tab>
          <Tab eventKey='billing' title='Billing & Payments'>
            <BillingPayments billingAddress={state.billingAddress} payment={state.payment} />
          </Tab>
          <Tab eventKey='invoices' title='Invoices'>
            <Invoices />
          </Tab>
        </Tabs>
      </Container>

      {/* Confirm Modal */}
      <Modal show={confirmModal.show} onHide={handleCloseConfirm} centered>
        <Modal.Header closeButton>
          <Modal.Title>{confirmModal.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{confirmModal.body}</Modal.Body>
        <Modal.Footer>
          <Button variant='outline-primary' onClick={handleCloseConfirm}>
            Close
          </Button>
          <Button variant='primary' onClick={handleConfirm}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Success Modal */}
      <Modal show={successModal.show} onHide={handleCloseSuccess} centered>
        <Modal.Body className='text-left'>
          <h4 className='fw-bold mb-3'>{successModal.title}</h4>
          <p className='text-muted'>{successModal.body}</p>
        </Modal.Body>
        <Modal.Footer className='justify-content-center'>
          <Button variant='outline-primary' onClick={handleCloseSuccess}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default SubscriptionManagementPage
